var React = require('react');

function ExpandInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.956 6.024H14v1.917H7.956V14H6.044V7.941H0V6.024h6.044V0h1.912z"}));
}

ExpandInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = ExpandInline;

ExpandInline.default = ExpandInline;
